<app-subheader [title]="'Mappa'" [backCta]="backCta" (emitBackCta)="goBack($event)"
               [styleClass]="'no-menu'"></app-subheader>
<app-map [props]="props" [centerInput]="centerInput"></app-map>
